// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__3s_Hl","containerItemsCenter":"Skeleton_containerItemsCenter___zcu5"};